import React from 'react';
import Constant from '../../constants';
import logo from '../../images/logo-back.svg';
import { useAppContext } from '../../app-context';
import { Link } from 'react-router-dom';
import styles from './Sidebar.module.scss';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

const Sidebar = () => {
  const { selectedPage, toggleSidebar } = useAppContext();
  return (
    <nav className={styles.sidebar}>
      <section className={styles.menuSide}>
        <span className={styles.websiteSide}>{Constant.WEBSITE_NAME}</span>
        <Link to={Constant.HOME_PAGE_ROUTE} onClick={toggleSidebar}>
          <h2
            className={`${
              selectedPage === Constant.HOME_PAGE_ROUTE
                ? styles.underlineSide
                : null
            }`}
          >
            {Constant.HOME_PAGE}
          </h2>
        </Link>
        <Link to={Constant.SIGNUP_PAGE_ROUTE} onClick={toggleSidebar}>
          <h2
            className={`${
              selectedPage === Constant.SIGNUP_PAGE_ROUTE
                ? styles.underlineSide
                : null
            }`}
          >
            {Constant.SIGNUP_PAGE}
          </h2>
        </Link>
        <Link to={Constant.LOGIN_PAGE_ROUTE} onClick={toggleSidebar}>
          <h2
            className={`${
              selectedPage === Constant.LOGIN_PAGE_ROUTE
                ? styles.underlineSide
                : null
            }`}
          >
            {Constant.LOGIN_PAGE}
          </h2>
        </Link>
        <Link to={Constant.CONTACT_PAGE_ROUTE} onClick={toggleSidebar}>
          <h2
            className={`${
              selectedPage === Constant.CONTACT_PAGE_ROUTE
                ? styles.underlineSide
                : null
            }`}
          >
            {Constant.CONTACT_PAGE}
          </h2>
        </Link>
        <div onClick={toggleSidebar}>
          <img className={styles.logoIcnSide} src={logo} alt='alpha-omega' />
        </div>
      </section>
    </nav>
  );
};

export default Sidebar;
